import React, { Component } from 'react';
import moment from 'moment';
import { FormattedNumber, injectIntl } from 'react-intl';

import './styles.css';

class Manifest extends Component {
  render() {
    const {
      intl,
      currentManifest,
    } = this.props;

    return (
      <div className="ManifestsInTransit__Manifest">
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Manifesto:</p>
            <p className="ManifestsInTransit--p">{currentManifest.manifestId}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Companhia:</p>
            <p className="ManifestsInTransit--p">{currentManifest.shippingGroupName}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Tracker:</p>
            <p className="ManifestsInTransit--p">{currentManifest.trackerId}</p>
          </div>
        </div>
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Data:</p>
            <p className="ManifestsInTransit--p">{currentManifest.date ? moment(currentManifest.date).format('DD/MM/YYYY') : ''}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Data de início:</p>
            <p className="ManifestsInTransit--p">{currentManifest.startDate ? moment(currentManifest.startDate).format('DD/MM/YYYY') : ''}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Data fim:</p>
            <p className="ManifestsInTransit--p">{currentManifest.endDate ? moment(currentManifest.endDate).format('DD/MM/YYYY') : ''}</p>
          </div>
        </div>
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Motorista:</p>
            <p className="ManifestsInTransit--p">{currentManifest.driver}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Celular:</p>
            <p className="ManifestsInTransit--p">{currentManifest.cellphone}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Placa:</p>
            <p className="ManifestsInTransit--p">{currentManifest.plate}</p>
          </div>
        </div>
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Pacotes:</p>
            <p className="ManifestsInTransit--p">{currentManifest.packages}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Peso:</p>
            <p className="ManifestsInTransit--p">{intl.formatNumber(currentManifest.weight)}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Valor:</p>
            <p className="ManifestsInTransit--p">R$ <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              currencyDisplay="symbol"
              value={currentManifest.value}
              useGrouping
            />
            </p>
          </div>
        </div>
        <div className="ManifestsInTransit--row-title">
          <h2 className="ManifestsInTransit--title">Caminhão</h2>
        </div>
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Marca:</p>
            <p className="ManifestsInTransit--p">{currentManifest.brand}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Modelo:</p>
            <p className="ManifestsInTransit--p">{currentManifest.model}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Tipo:</p>
            <p className="ManifestsInTransit--p">{currentManifest.truckType}</p>
          </div>
        </div>
        <div className="ManifestsInTransit--row-title">
          <h2 className="ManifestsInTransit--title">Carroceria</h2>
        </div>
        <div className="ManifestsInTransit--row">
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Marca:</p>
            <p className="ManifestsInTransit--p">{currentManifest.cBrand}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Modelo:</p>
            <p className="ManifestsInTransit--p">{currentManifest.cModel}</p>
          </div>
          <div className="ManifestsInTransit--col">
            <p className="ManifestsInTransit--p ManifestsInTransit--label">Tipo:</p>
            <p className="ManifestsInTransit--p">{currentManifest.cTruckType}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Manifest);
